import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import DrawerCustom from '../component/Drawer';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import BlockedNumberTable from './BlockedNumberTable';
import { Divider } from '@mui/material';
const drawerWidth = 240;



export default function ConfigurationCAF() {
    const [value, setValue] = React.useState(30);

    const handleSliderChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleInputChange = (event) => {
        setValue(event.target.value === '' ? '' : Number(event.target.value));
    };

    const handleBlur = () => {
        if (value < 0) {
            setValue(0);
        } else if (value > 100) {
            setValue(100);
        }
    };

    
  return (
  <Box sx={{ display: 'flex' }}>
    <CssBaseline />
    <DrawerCustom />
    <Box component="main" >
    <Grid xs={12}> 
    <Typography variant="h3" sx={{ marginTop: 5 }}>Customer Relations Configurations</Typography>
    <Divider sx={{ marginBottom: 2, width: '55%' }} />
    <Typography className="uiSubHeaderFont" sx={{ fontSize: 18,  width: '85%' }}>
        Configurations for the Customer Relations team to add blocked numbers to the CR Blocked Number Data Table within Genesys Cloud.{" "}
    </Typography>
    </Grid> 
    <Grid xs={12}> 
    <BlockedNumberTable />
    </Grid>  
  </Box>
</Box>
  );
}